import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/manifests/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/manifests" });
  },
});